/** @module ProductSpec/IncrementSizesRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductSize/_SizesRenderer",
	"./IncrementSizesMixin"
], function (declare,lang,_,Action,ViewRef,xml,Query,_SizesRenderer,IncrementSizesMixin) {

	return declare ([_SizesRenderer, IncrementSizesMixin], {
		/**
		 * @override
		 * Return size range for increment
		 */
		getSizeRange: function(ctx) {
			return ctx.cache.get(ctx.getNode()?.IncrementSizeRange);
		},

		/**
		 * @override
		 * Return product sizes reference by increment sizes
		 */
		getSizes: function(view, sizeRange) {
			const increment = view.getViewNode();
			const incrementSizes = view.cacheView.getNodes(increment?.Sizes);
			return _.pluck(incrementSizes, "IncrementSize");
		},

		/**
		 * @override
		 * Return Action including ViewRef and optionally Filter and FilterView to select defaults;
		 * if Increment has NO SizeRange, all 1-d sizes can be selected
		 */
		_getStoreAction: function(ctx, h) {
			var sizeRangeUrl = this.getCurrentSizeRangeUrl(this._getIncrement(ctx));
			var hasSizeRange = xml.isValidURL(sizeRangeUrl);
			return lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
	                m_id: "Sizes",
	                m_url: hasSizeRange ?  sizeRangeUrl : "centric://APPAREL/Views"
				}),
				m_fixedQuery: hasSizeRange ? null : new Query().Attr("IsTwoDim", xml.OP_EQUALS, false)
			});
		}
	});
});